import style from './style.scss';

/**
 * The RainRateStatus component displays the current rain rate information
 * on the home page.
 *
 * props:
 * - rainRate: The current rainfall rate
 * - rainUnit: The current rainfall unit
 * - rainRateFormatter: A function used for formatting the rainfall rate for display
 */

const RainRateStatus = props => {

	const { rainRate, description, rainUnit, rainRateFormatter } = props;

	if (rainRate === 0) {
		return <div class={style.rain_rate_dry}>{ description }</div>;
	}

	let cssClass;

	switch (description) {
		case 'Light rain/drizzle':
		case 'Light rain':
			cssClass = style.rain_icon_light;
			break;
		case 'Moderate rain':
			cssClass = style.rain_icon_moderate;
			break;
		case 'Heavy rain':
			cssClass = style.rain_icon_heavy;
			break;
		case 'Very heavy rain':
		case 'Torrential rain':
			cssClass = style.rain_icon_very_heavy;
			break;
	}

	return (
		<div class={style.rain_rate_box}>
			<div class={cssClass} />
			<div class={style.rain_rate_data}>
				<div class={style.rain_rate_descriptor}>{ description }</div>
				<div class={style.rain_rate_value}>
					<span>{ rainRateFormatter(rainRate) }</span>
					<span class={style.rain_rate_unit}> { rainUnit + '/hr' }</span>
				</div>
			</div>
		</div>
	);

};

export default RainRateStatus;



// WEBPACK FOOTER //
// ./components/rain-rate-status/index.js